import "./src/styles/global.css";
import { siteContent } from "./src/content/siteContent";

export function onRouteUpdate({ location, prevLocation }) {
  if (!prevLocation || typeof window === "undefined" || typeof window.ym !== "function") return;

  window.ym(siteContent.yandexMetrikaId, "hit", location.pathname + location.search, {
    referer: `${window.location.origin}${prevLocation.pathname}${prevLocation.search}`
  });
}
